import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit} from '@angular/core';
import '@luigi-project/container';
import {UntilDestroy} from '@ngneat/until-destroy';
import {LuigiContainer} from '@luigi-project/container';
import {OAuthService} from 'angular-oauth2-oidc';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import jwt_decode, {JwtPayload} from 'jwt-decode';
import {ConfigService} from '@dcp/configurator';

interface UserJwtPayload extends JwtPayload {
  company_country: string;
  groups: string[];
}

interface ChatAdvisorContext {
  idToken: string | null;
  country: string | null,
  isSapEmployee: boolean;
}

@UntilDestroy()
@Component({
  selector: 'dcp-chat-advisor',
  standalone: true,
  templateUrl: './chat-advisor.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChatAdvisorComponent implements OnInit {
  private oAuthService = inject(OAuthService);
  private authService = inject(DcpAuthService);
  private configService = inject(ConfigService);
  public container: LuigiContainer;

  public url: string

  public context: ChatAdvisorContext = {
    idToken: null,
    country: null,
    isSapEmployee: false
  }

  ngOnInit(): void {
    this.populateContext()
    this.url = this.configService.getString('urls.productAdvisorChat')

    this.container = document.querySelector('#advisor-chat');
    this.container.addEventListener('advisor.request.login', () => {
      this.authService.loginWithRedirect();
    });
  }

  //tbd - remove after geol-service update
  getCookie(name: string): string {
    return Object.fromEntries(
      document.cookie.split('; ').map(c => c.split('='))
    )[name] || null;
  }

  private populateContext(): void {
    this.context.country = this.getCookie('country') || null;
    const jwt = this.oAuthService.getAccessToken();

    if (jwt) {
      const decodedJwt = jwt_decode<UserJwtPayload>(jwt);
      this.context.idToken = jwt;
      this.context.isSapEmployee = decodedJwt.groups.includes('EMPLOYEE');
    }
  }
}
